/* CoolBreeze Direct — behaviour layer.
   Two small things Dawn does not do, both mirrored from coolbreezehvac.com:
   the header gains a shadow past 20px, and sections fade up on first view. */

(function () {
  'use strict';

  /* Header shadow on scroll — the HVAC site's `isScrolled` state. */
  var header = document.querySelector('.section-header');

  if (header) {
    var ticking = false;

    var sync = function () {
      header.classList.toggle('cbd-scrolled', window.scrollY > 20);
      ticking = false;
    };

    sync();

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(sync);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* Reveal-on-scroll for anything tagged [data-cbd-reveal]. */
  var reveal = function (root) {
    var targets = (root || document).querySelectorAll('[data-cbd-reveal]:not(.cbd-revealed)');

    if (!targets.length) return;

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      targets.forEach(function (el) {
        el.classList.add('cbd-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (!entry.isIntersecting) return;
          // Stagger siblings so a grid cascades rather than popping at once.
          entry.target.style.transitionDelay = Math.min(i * 70, 350) + 'ms';
          entry.target.classList.add('cbd-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  };

  reveal();

  /* Belt and braces: if an observer never fires (editor iframes, odd
     browsers), anything near the viewport is shown after a beat anyway. */
  window.setTimeout(function () {
    document.querySelectorAll('[data-cbd-reveal]:not(.cbd-revealed)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 1.2) {
        el.classList.add('cbd-revealed');
      }
    });
  }, 2500);

  /* Category strip: on a phone it scrolls sideways, so bring the active
     pill into view instead of leaving it cut off at the right edge. */
  document.querySelectorAll('.cbd-catnav__list').forEach(function (list) {
    var active = list.querySelector('.is-active');
    if (!active || list.scrollWidth <= list.clientWidth) return;
    list.scrollLeft = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
  });

  /* Hero photo rotation. Pure crossfade on a timer; the first photo is
     already visible in the HTML so nothing depends on this running. */
  var slideshows = function (root) {
    (root || document).querySelectorAll('[data-cbd-slideshow]:not([data-cbd-slideshow-ready])').forEach(function (hero) {
      var slides = hero.querySelectorAll('.cbd-hero__slide');
      hero.setAttribute('data-cbd-slideshow-ready', '');
      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var index = 0;
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
      var timer = window.setInterval(function () {
        if (document.hidden) return;
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, interval);

      hero.addEventListener('cbd:slideshow:stop', function () {
        window.clearInterval(timer);
      });
    });
  };

  slideshows();

  /* Fix-It Fridays player: the poster is a button; the YouTube iframe is
     only created on play. Episode cards load their video into the player
     instead of leaving the page; without JS they are plain YouTube links. */
  var loadVideo = function (player, id, autoplay) {
    var stage = player.querySelector('.cbd-player__stage');
    if (!stage) return;
    stage.innerHTML = '';
    var frame = document.createElement('iframe');
    frame.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?rel=0&modestbranding=1&playsinline=1' +
      (autoplay ? '&autoplay=1' : '');
    frame.title = player.querySelector('[data-video-title]')?.textContent || 'Episode';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('loading', 'lazy');
    stage.appendChild(frame);
    player.setAttribute('data-video-id', id);
  };

  var players = function (root) {
    (root || document).querySelectorAll('cbd-video:not([data-ready])').forEach(function (player) {
      player.setAttribute('data-ready', '');
      var poster = player.querySelector('[data-video-play]');
      if (poster) {
        poster.addEventListener('click', function () {
          loadVideo(player, player.getAttribute('data-video-id'), true);
        });
      }

      var section = player.closest('section') || document;
      section.querySelectorAll('[data-video-card]').forEach(function (card) {
        card.addEventListener('click', function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey) return;
          event.preventDefault();
          var id = card.getAttribute('data-video-id');
          loadVideo(player, id, true);
          var title = player.querySelector('[data-video-title]');
          if (title) title.textContent = card.getAttribute('data-video-title') || '';
          section.querySelectorAll('.cbd-episode.is-playing').forEach(function (el) {
            el.classList.remove('is-playing');
          });
          card.closest('.cbd-episode')?.classList.add('is-playing');
          player.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    });
  };

  players();

  /* sms: links do nothing on most desktops. On a mouse-driven device that is
     not a Mac (Macs can hand off to Messages), send those taps to the contact
     page instead, where every way to reach a tech is listed. */
  var smsFallback = function (root) {
    var desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var mac = /Mac/i.test(navigator.platform || '') && !/iPhone|iPad/i.test(navigator.userAgent);
    if (!desktop || mac) return;
    (root || document).querySelectorAll('a[href^="sms:"]:not([data-cbd-sms-kept])').forEach(function (a) {
      a.setAttribute('data-cbd-sms-original', a.getAttribute('href'));
      a.setAttribute('href', '/pages/contact#ways');
      a.setAttribute('title', 'Texting works from your phone. On a computer this opens our contact page.');
    });
  };

  smsFallback();

  /* Re-run when the theme editor swaps a section in. */
  document.addEventListener('shopify:section:load', function (event) {
    reveal(event.target);
    slideshows(event.target);
    players(event.target);
    smsFallback(event.target);
  });
})();
